<ls-skiplinks [links]="[
{id:'main', name: 'Contenu'},
{id:'footer', name: 'Pied de page'},
{id:'menu', name: 'Menu'}
]">
</ls-skiplinks>

@if (!disabledAccount) {
  <div class="app-container">
    <app-topbar></app-topbar>
    <div id="main" tabindex="-1" class="max-height">
      <router-outlet></router-outlet>
    </div>
    <app-footer tabindex="-1" id="footer"></app-footer>
  </div>
}

@if (disabledAccount) {
  <div class="d-flex flex-column align-items-center mt-5">
    Ce compte est désactivé, s'il s'agit d'une erreur merci de contacter <a href="mailto:contact.portail@libriciel.fr">contact.portail&#64;libriciel.fr</a>
    <button (click)="logout()" class="btn btn-primary mt-3">
      <fa-icon icon="sign-out-alt"></fa-icon>
      Se déconnecter
    </button>
  </div>
}

<ls-back-to-top class="d-none d-md-block"></ls-back-to-top>
